/*eslint-disable */
const $ = window.jQuery = require('jquery');

import aboutOfUserInfo from '@/components/private/user/about-of-user-info/index.vue';
import addAboutOfUserInfo from '@/components/private/user/add-about-of-user-info/index.vue';
import authorizedUserForDemoRequest from '@/components/private/user/authorized-user-for-demo-request/index.vue';
import axios from 'axios';
import { bus } from '@/main';
import countries from '@/services/country.json'
import fullBioPopup from '@/components/private/dashboard/full-bio-for-popup/';
import { mapGetters } from 'vuex';
import toast from '@/services/toast';

export default {
  name: 'home-dashboard',
  components: {
    'about-user-info' : aboutOfUserInfo,
    'add-about-user-info' : addAboutOfUserInfo,
    'authorized-user-for-demo-request':authorizedUserForDemoRequest,
    'full-bio-popup' : fullBioPopup
  },
  props: [],
  data () {
    return {
      userDetails:null,
      loadmoreData: {},
      userLoading: false,
      nextStep:'',
      bioFullData:'',
      bioFullDataPopup:false,
      blogListState:null,
      blogListResults:[],
      publicBlogListState:null,
      publicBlogListResults:[],
      selfUserId:'',
      pubBlogState:true,
      is_guestuser:false,
      is_superuser:false,
      blogActv:'blog',
      blogRemovedPopup:false,
      removeBlogId:'',
      profileUpdateAlertPopup:false,
      countryList:[],
      aboutUserInfoPopupState:false,
      getAboutInfo:'',
      addAboutPopupState:false,
      isMobile:false,
      authorizedUserDemoForReqState:false,
      file:null,
      myCvReUploadSection:false,
      cvUploadLoader:false
    }
  },
  computed: {
    ...mapGetters([
      'acUserDetailsStateGetters',
      'publicBlogListGetters',
      'blogListGetters',
      'getAboutDetailsOfProfileGetters'
    ]),
  getUserDetailsAgainFun(){
    this.userDetails = this.$store.getters.acUserDetailsStateGetters.data
    return
  },
  SetIntialUserStatus(){
    if (this.userDetails) {
      this.is_guestuser = this.userDetails.guest
      this.is_superuser = this.userDetails.is_superuser
    }
    return
  },
  getBlogListFun(){
    this.blogListState = this.$store.getters.blogListGetters.data
    return
  },
  setInitialBlogStates(){
    if(this.blogListState){
      this.blogListResults = this.blogListState.results
    }
  },
  getPubBlogListFun(){
    this.publicBlogListState = this.$store.getters.publicBlogListGetters.data
    return
  },
  setInitialPubBlogStates(){
    if(this.publicBlogListState){
      this.publicBlogListResults = this.publicBlogListState.results
    }
  },
  getAboutInfoFun(){
    this.getAboutInfo = this.$store.getters.getAboutDetailsOfProfileGetters.data
    return
  }
  },
  mounted () {
    if(localStorage.getItem('LoginedUserID')){
      this.selfUserId = localStorage.getItem('LoginedUserID')
    }
    Object.keys(countries).map((key, index) => {
      this.countryList.push({
        name: countries[key].toLowerCase(),
        value: key.toLowerCase()
      })
    });
    this.countryList.sort((a, b) => (a.name > b.name) ? 1 : -1)
    this.getUserDetailsAgainFun;
    this.getBlogListFun;
    this.setInitialBlogStates;
    this.getPubBlogListFun;
    this.setInitialPubBlogStates;
    this.getAboutInfoFun;
    bus.$on('aboutUserInfoPopupStateBus', (data) => {
      this.aboutUserInfoPopupState = data
      this.myCvReUploadSection = false
    });
    bus.$on('addAboutPopupStateBus', (data) => {
      this.addAboutPopupState = data
      this.myCvReUploadSection = false
    });
    bus.$on('authorizedUserDemoForReqStateBus', (data) => {
      this.authorizedUserDemoForReqState = data
    });
    bus.$on('bioFullDataPopupBus', (data) => {
      this.bioFullDataPopup = data
    });
  },
  methods: {
    downloadFile(url, filename) {
      const xhr = new XMLHttpRequest();
      xhr.responseType = 'blob';
      xhr.onload = function() {
        const url = URL.createObjectURL(this.response);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(url);
      };
      xhr.open('GET', url);
      xhr.send();
    },    
    deleteCvFromMyBucketMethod(){
      this.$store.dispatch('deleteCVbyUserIdAction').then((res) => {
        toast.success("Cv deleted has been successfully"); 
        this.myCvReUploadSection = false
        this.$store.dispatch('getAboutDetailsOfProfileFun')
      }).catch((err) => {
      })
    },
    cvTabChangedMethod(){
      if(this.myCvReUploadSection == true){
        this.myCvReUploadSection = false
      }else{
        this.myCvReUploadSection = true
      }
    },
    handleReuploadCvUploadMethod(event) {
      if(event.target.files && event.target.files.length > 0) {
        const file = event.target.files[0];
        this.file = event.target.files[0];
        this.$store.dispatch('deleteCVbyUserIdAction').then((res) => {
          var formData = new FormData();
          formData.append('cv', this.file);
          formData.append('cv_filename', file.name);
          formData.append('pdf_cv', this.file);
          this.cvUploadLoader = true;
          this.$store.dispatch('uploadUsrCVAction', formData).then((res) => {
            toast.success(res.data.msg); 
            this.cvUploadLoader = false;
            this.$store.dispatch('getAboutDetailsOfProfileFun')
          }).catch((err) => { 
            this.cvUploadLoader = false;
            this.file = null
          })
        })
      }
    },
    handleCVUploadMethod(event) {
      if(event.target.files && event.target.files.length > 0) {
        const file = event.target.files[0];
        this.file = event.target.files[0];
        var formData = new FormData();
        formData.append('cv', this.file);
        formData.append('cv_filename', file.name);
        formData.append('pdf_cv', this.file);
        this.cvUploadLoader = true;
        this.$store.dispatch('uploadUsrCVAction', formData).then((res) => {
          toast.success(res.data.msg); 
          this.cvUploadLoader = false;
          this.$store.dispatch('getAboutDetailsOfProfileFun')
        }).catch((err) => { 
          this.cvUploadLoader = false;
          this.file = null
        })
      }
    },
    authorizedUserDemoForReqStatePopup(){
      document.body.classList.add('body_right_scroll_remove');
      this.authorizedUserDemoForReqState =  true
    },
    onResize() {
      this.isMobile = window.innerWidth < 769
    },
    openAddAboutPopup(){
      document.body.classList.add('body_right_scroll_remove');
      this.addAboutPopupState =  true
    },
    openUpdateAboutPopup(){
      document.body.classList.add('body_right_scroll_remove');
      this.aboutUserInfoPopupState = true
    },
    getHtmlValOfEditor(htmlString){
    var stripedHtml = $("<div>").html(htmlString).text();
    // var newStripedHtml = stripedHtml.replace(':', /(\n)/g)
    var customItems = stripedHtml.split(":");
    for (let i = 0; i < customItems.length; i++) {
      customItems[i] = customItems[i] + "\n";
    }
    customItems = customItems.join("");
    return customItems;
    },
    userInfoAlertPopupOpenFun(){
      document.body.classList.add('body_right_scroll_remove');
      this.profileUpdateAlertPopup =  true
    },
    userInfoAlertPopupClosedFun(){
      document.body.classList.remove('body_right_scroll_remove');
      this.profileUpdateAlertPopup =  false
    },
    getRemoveListAgain(){
      this.$store.dispatch('getBlogListAction').then((res)=>{
        this.blogListState = res.data.data
      }).catch((err)=>{
        
      })
      this.$store.dispatch('getPublicBlogListAction').then((res)=>{
        this.publicBlogListState = res.data.data
      }).catch((err)=>{
        
      })
    },
    openRemoveBlogPopup(id){
      document.body.classList.add('body_right_scroll_remove');
      this.blogRemovedPopup = true
      this.removeBlogId = id
    },
    removeModalItemConfirmFun(){
      this.$store.dispatch('removeBlogDetailsAction', {
        id: this.removeBlogId,
      })
      .then((res) => {
        if (res.status == '200') {      
          toast.success(res.data.msg); 
          $('body').removeClass('body_right_scroll_remove')
          this.blogRemovedPopup = false
          this.removeBlogId = ''
          this.getRemoveListAgain()
        }
      }).catch((err) => {
        toast.error(err.data.user_msg);  
      })
    return;
    },
    closeRemoveItemModalFun(){
      document.body.classList.remove('body_right_scroll_remove');
      this.blogRemovedPopup = false
      this.removeBlogId = ''
    },
    homeFilterFun(checkItem, param){
      $('.total_count_box').removeClass('active');
      $('#homeFilterTab' + param).addClass('active');
      this.blogActv = checkItem
    },
    OnlyShowMyBLogsFun(){
      if(this.pubBlogState === true){
        this.pubBlogState = false
      }else{
        this.pubBlogState = true
      }
    },
    bioReadMoreFun(data){
      this.bioFullData = data
      this.bioFullDataPopup = true
      document.body.classList.add('body_right_scroll_remove');
      // var __self = this
      // $(document).click(function (event) {
      //   //if you click on anything except the modal itself or the "open modal" link, close the modal
      //   if (!$(event.target).closest(".bio_text_read_more,.bio_more_data_popup_modal").length) {
      //     __self.bioFullData = ''
      //     __self.bioFullDataPopup = false
      //     document.body.classList.remove('body_right_scroll_remove');
      //   }
      // });
    },
    showLoadMoreDataFun(url) {
      this.userLoading = true
      console.log(url, "Next URL LINK")
      axios.get(url).then((response) => {
        console.log(response.data.data.next)
          this.loadmoreData = response.data
          this.nextStep = this.loadmoreData.data.next
          this.$set(this.userUpdatesList, 'next', this.nextStep)
          if (this.loadmoreData != undefined) {
            for (var i = 0; i < this.loadmoreData.data.results.length; i++) {
              this.userUpdatesList.push(this.loadmoreData.data.results[i]);
              this.userLoading = false
            }
          }
        });
    },
    getUserDetailsAgain() {
      this.$store.dispatch('getAcUserDetailsFun').then((res) => {
        this.userDetails = res.data.data
      }).catch((err) => {
      })
    },
    userStatusUpdatedFun(userDetails, userStatus){
      var is_public = userStatus
      if(userStatus == false){
        is_public = true
      }else{
        is_public = false
      }
      // console.log(userStatus, is_public, "User Status CHecking")
      let data = new FormData();
      data.append('is_public', is_public);
      this.$store.dispatch('updateProfileFun', data)
        .then((res) => {
          toast.success(res.data.msg);
          this.getUserDetailsAgain()
        }).catch((err) => {
          toast.error(err.data.user_msg || err.data.data.email);
        })
      return;
    },
    getCountryName(countryCode) {
      if (countryCode == null) {
        countryCode = ''
      }
      let countryName = countryCode.toLowerCase()
      let country = this.countryList.filter(item => (item.value) == (countryName) || (item.name) == (countryName));
      if (country && country.length > 0) {
        country = country[0]
        country = country.name
      } else {
        country = ''
      }
      return country;
    },
  },
  watch:{
    getUserDetailsAgainFun(){
      return this.$store.getters.acUserDetailsStateGetters
    },
    SetIntialUserStatus(){
      if (this.userDetails) {
        this.is_guestuser = this.userDetails.guest
        this.is_superuser = this.userDetails.is_superuser
      }
      return
    },
    getBlogListFun(){
      return this.$store.getters.blogListGetters
    },
    setInitialBlogStates(){
      if(this.blogListState){
        this.blogListResults = this.blogListState.results
      }
    },
    getPubBlogListFun(){
      return this.$store.getters.publicBlogListGetters
    },
    setInitialPubBlogStates(){
      if(this.publicBlogListState){
        this.publicBlogListResults = this.publicBlogListState.results
      }
    },
    getAboutInfoFun(){
      return this.$store.getters.getAboutDetailsOfProfileGetters
    }
  },
  beforeRouteLeave: function(to, from, next) {
    document.body.classList.remove('body_right_scroll_remove');
    next();
  },
  created () {
    window.addEventListener('resize', this.onResize, { passive: true })
    this.onResize()
  },
  beforeDestroy () {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize, { passive: true })
    }
  },
}